import React, { useState, useLayoutEffect, useEffect } from "react"
import { Link } from "gatsby"

const ProgressBar = ({ post, articleRef }) => {
  
    // https://codedaily.io/tutorials/79/Create-an-Animated-Circular-Progress-Indicator-to-Track-Article-Read-Percentage-in-React
    const [progress, setProgress] = useState(0)
  
    useLayoutEffect(() => {
      const updateHeight = () => {
        if (!articleRef.current) return
        const { height } = articleRef.current.getBoundingClientRect()
        setProgress(window.scrollY / (height-600 - window.innerHeight / 5))
      }
  
      updateHeight()
  
      window.addEventListener("scroll", updateHeight)
      return () => {
        window.removeEventListener("scroll", updateHeight)
      }
    })
  
    const position = Math.min(Math.max(progress * 100, 0), 100)
  
    // https://stackoverflow.com/questions/57453141/using-react-hooks-to-update-w-scroll
    const [scrolling, setScrolling] = useState(true)
    const [scrollTop, setScrollTop] = useState(0)

    let backButton = {
        link : '',
        text : ''
    }

    // Set the back button link and text depending on the component
    switch (post?.content?.component) {
        case 'magazine':
            backButton.link = '/cx-insights-hub/'
            backButton.text = 'CX INSIGHTS HUB'
            break;
        case 'news_and_opinion':
            backButton.link = '/news-opinion/'
            backButton.text = 'NEWS'
            break;
        case 'book_review':
            backButton.link = '/book-reviews/'
            backButton.text = 'BOOK REVIEWS'
            break;
        default:
            break;
    }
  
    useEffect(() => {
      let currentPosition = window.pageYOffset
      function onScroll() {
        currentPosition = window.pageYOffset
        if (window.scrollY > 200 && window.innerWidth >= 1024) {
          if (currentPosition > scrollTop) {
            setScrolling(false)
            document.getElementById('navbar').style.transform = 'translateY(-7rem)'
          } else {
            setScrolling(true)
            document.getElementById('navbar').style.transform = 'translateY(0)'
          }
        }
        setScrollTop(currentPosition <= 0 ? 0 : currentPosition)
      }
  
      window.addEventListener("scroll", onScroll)
      return () => window.removeEventListener("scroll", onScroll)
    }, [scrollTop])
  
    return (
      <div
        className={`sticky-nav bg-white fixed w-full z-50 transition-all duration-500 ease-in-out hidden lg:block  ${
          scrolling ? "-top-16" : "top-0"
        }`}
      >
        <div className="px-14 py-4 flex justify-between">
          <div className="block relative items-center">
            <Link
              to={backButton.link}
              className="text-darkgrey font-display font-bold text-base tracking-widest uppercase mx-3 py-4 hover:text-gold duration-500 ease-in-out"
            >
              <i className="fas fa-chevron-left mr-2 text-xs"></i>{backButton.text}
            </Link>
          </div>
          <div className="reading">
            <span className="text-darkgrey font-display font-bold text-base tracking-widest uppercase mx-3 py-4">
              Reading:{" "}
            </span>{" "}
            <i className={`text-sm ${post?.content?.component === 'magazine' ? 'font-insights-body' : 'font-body'}`}>{post?.name}</i>
          </div>
          <div className="social">
            <div className="text-left flex items-center">
              <h4 className="text-darkgrey font-display font-bold text-base tracking-widest uppercase mr-5">
                Share:{" "}
              </h4>
              <div className="space-x-4 text-base">
                <a
                  href={`https://twitter.com/share?url=https://www.tlfresearch.com/${post?.full_slug}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i
                    className="fab fa-twitter text-darkgrey hover:text-red transition duration-300 ease-in-out"
                    aria-label="Twitter"
                  ></i>
                </a>
                <a
                  href={`http://www.facebook.com/sharer.php?u=https://www.tlfresearch.com/${post?.full_slug}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <i
                    className="fab fa-facebook text-darkgrey hover:text-red transition duration-300 ease-in-out"
                    aria-label="Facebook"
                  ></i>
                </a>
                <a
                  href={`mailto:?subject=${post?.name}&body=Check out this Case Study on TLF research: https://www.tlfresearch.com/${post?.full_slug}`}
                >
                  <i
                    className="far fa-envelope text-darkgrey hover:text-red transition duration-300 ease-in-out"
                    aria-label="Email"
                  ></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full h-0.5 bg-white top-full absolute shadow">
          <div
            className="test bg-red h-full"
            Style={`width: ${position}%`}
          ></div>
        </div>
      </div>  
    )
  }

  export default ProgressBar